import { Component } from '@angular/core';
import {NgClass, NgForOf, NgIf} from "@angular/common";
import {ItemsDashboardAutorizacionesService} from "../../services/items-dashboard-autorizaciones.service";
import {RouterLink} from "@angular/router";
import {LoginServices} from "../../../../auth/login/services/login.service";

@Component({
  selector: 'app-dashboard',
  standalone: true,
    imports: [
        NgForOf,
        NgIf,
        RouterLink,
        NgClass
    ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent {

    constructor(protected itemsDashboardAutorizacionesService:ItemsDashboardAutorizacionesService, public loginServices: LoginServices) {
    }
}
